/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';


/**
 * Manja Image Zoom Widget ( .mjImageZoomWidget )
 *
 * methods:
 *  - TODO
 *
 * usage:
 *  $('#container').mjImageZoomWidget( { ... } )
 *
 */

(function($) {


	// using the new $.widget utility..
	$.widget( 'mj.mjImageZoomWidget', {

		options: {

		},

		_create: function() {
			var thisWidget = this;

			// init state
			this._zoom_stack = [];
			this._src_w = 2;
			this._src_h = 2;
			this._views = [];

			// add html controls
			this.element.append( '<div class="md-view-ctrls" style="display:none;">'
									+'<div title="'+mjt('md-zoom-in')+'" class="md-view-ctrl md-zoom-in"></div>'
									+'<div title="'+mjt('md-zoom-out')+'" class="md-view-ctrl md-zoom-out"></div>'
									+'<div title="'+mjt('md-zoom-100')+'" class="md-view-ctrl md-zoom-100"></div>'
								+'</div>' );
			var md_view_ctrls = this.element.children('.md-view-ctrls');

			// bind event handlers
			md_view_ctrls
				.children('.md-zoom-in').click( function() {
					thisWidget.zoomIn(); return false;
				} ).end()
				.children('.md-zoom-out').click(  function() {
					thisWidget.zoomOut(); return false;
				} ).end()
				.children('.md-zoom-100').click(  function() {
					thisWidget.zoom100(); return false;
				} );

			//md_view_ctrls.show();

			/*???
			// bind resize handler
			this.element.on( 'mjsresize.mjMediaPageNavWidget', function(e,w,h) {
				thisWidget._center_page_ctrls(w,h);
			});
			// bind show handler
			this.element.on( 'mjsshow.mjMediaPageNavWidget', function(e) {
				thisWidget._center_page_ctrls(null,null);
			});
			*/
		},


		_zoomTo: function( area, initial, replace_on_stack, do_trigger ) {
			var c_x = Math.round(area[0]),
				c_y = Math.round(area[1]),
				c_w = Math.round(area[2]),
				c_h = Math.round(area[3]);
			if( initial ) {
				this._zoom_stack = [ area ];
			} else {
				this._zoom_stack[this._zoom_stack.length-(replace_on_stack?1:0)] = area;
			}

			var md_view_ctrls = this.element.children('.md-view-ctrls');
			md_view_ctrls
				.children('.md-zoom-in').show().end()
				.children('.md-zoom-out').css( 'opacity', this._zoom_stack.length<=1 ? '0.3' : '1.0' ).show().end()
				.children('.md-zoom-100').css( 'opacity', this._zoom_stack.length<=1 ? '0.3' : '1.0' ).show().end()
				.show();

			if( do_trigger ) {
				this._trigger( 'zoom_changed', null, { area: [c_x,c_y,c_w,c_h] } );
			}
		},

		_JcropSelectCoords: function( view, c ) {
			if( c.w>1 && c.h>1 ) {
				// compute dimensions in original image
				var cur = this._zoom_stack[this._zoom_stack.length-1],
					sx = cur[2] / view.view_w,
					sy = cur[3] / view.view_h;
				c.x = ( c.x*sx + cur[0] );
				c.y = ( c.y*sy + cur[1] );
				c.w = c.w*sx;
				c.h = c.h*sy;
				// clip area
				if( c.x < 0 ) {
					c.w += c.x;
					c.x = 0;
				}
				if( c.y < 0 ) {
					c.h += c.y;
					c.y = 0;
				}
				if( view.src_w>0 && c.x + c.w > view.src_w ) c.w = view.src_w - c.x;
				if( view.src_h>0 && c.y + c.h > view.src_h ) c.h = view.src_h - c.y;
				if( c.w < 2 || c.h < 2 ) {
					if( c.w < 2 ) c.w = 2;
					if( c.h < 2 ) c.h = 2;
				}
				this._zoomTo( [c.x,c.y,c.w,c.h], false, false, true );
			}
		},

		_onJcropSelect: function( view_idx, coords ) {
			if( view_idx>=this._views.length || view_idx<0 ) return; // no-op
			var view = this._views[view_idx];
			this._JcropSelectCoords( view, coords );
		},

		resetViews: function( reset_stack, src_w, src_h ) {
			for( var i=0; i<this._views.length; ++i ) this._views[i].img_or_canvas.Jcrop('destroy');
			this._src_w = src_w;
			this._src_h = src_h;
			this._views = [];
			if( reset_stack ) {
				this._zoomTo( [0,0,src_w,src_h], true, false, false );
			}
		},

		addView: function( img_or_canvas, src_w, src_h, view_w, view_h ) {
			var thisWidget = this;
			var view_idx = this._views.length;
			var view = {	view_idx: view_idx,
				img_or_canvas: img_or_canvas,
				src_w: src_w,
				src_h: src_h,
				view_w: view_w,
				view_h: view_h };
			this._views.push( view );
			img_or_canvas.Jcrop( {
				onSelect: function( coords ) {
					thisWidget._onJcropSelect(view_idx,coords);
				},
				boxWidth: view_w,
				boxHeight: view_h,
				bgColor: 'transparent',
				shadeColor: '#888888',
				allowMove: false,
				allowResize: false,
				keySupport: false,
			} );
		},

		zoomIn: function() {
			if( this._views.length<1 ) return; // no-op
			var view = this._views[0];
			if( this._zoom_stack.length>=1 ) {
				var area = this._zoom_stack[this._zoom_stack.length-1],
					w = area[2]*0.666666667,
					h = area[3]*0.666666667,
					x = area[0]+0.5*(area[2]-w),
					y = area[1]+0.5*(area[3]-h),
					cur = area,
					sx = cur[2]/view.view_w,
					sy = cur[3]/view.view_h;
				w /= sx;
				h /= sy;
				x = (x-cur[0])/sx;
				y = (y-cur[1])/sy;
				this._JcropSelectCoords( view, {x:x,y:y,w:w,h:h} );
			}
		},

		zoomOut: function() {
			if( this._zoom_stack.length >= 2 ) {
				var area = this._zoom_stack[this._zoom_stack.length-2];
				this._zoom_stack.length -= 2;
				this._zoomTo( area, this._zoom_stack.length==0, false, true );
			} else if( this._zoom_stack.length == 1 ) {
				this.zoom100();
			}
		},

		zoom100: function() {
			var area = this._zoom_stack[0];
			this._zoom_stack.length = 0;
			this._zoomTo( area, true, false, true );
		},

		_destroy: function() {
			// stop all active timeouts
			// ...none yet...TODO...
			// remove all event handlers
			$(document).off('.mjImageZoomWidget');
			this.element.off('.mjImageZoomWidget');
			// destroy views
			this.resetViews();
			// remove all controls
			this.element.children('.md-view-ctrls').remove();
		},

	} );

})(jQuery);

